export default __webpack_public_path__ + "static/blob-55-15420bd0f46ddff057be0b50f5ae5cd2.svg";